// extracted by mini-css-extract-plugin
export var hero = "home-module--hero--3kPNJ";
export var hero_image = "home-module--hero_image--BBBQd";
export var our_work = "home-module--our_work--L4NJX";
export var content = "home-module--content--3ojw_";
export var home_image = "home-module--home_image--3P0-D";
export var card_list = "home-module--card_list--3Rf0E";
export var hero_content_left = "home-module--hero_content_left--3XlS2";
export var hero_grid = "home-module--hero_grid--2zI4t";
export var hero_content_right = "home-module--hero_content_right--2QbGA";
export var content_grid = "home-module--content_grid--Z2Rpu";
export var content_item = "home-module--content_item--kFgx9";